import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var MenuPositions;
(function (MenuPositions) {
    MenuPositions["LEFT"] = "left";
    MenuPositions["RIGHT"] = "right";
})(MenuPositions || (MenuPositions = {}));
var propTypes = {
    menuPosition: PropTypes.oneOf(['left', 'right']).isRequired,
    triggerElement: PropTypes.node.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool,
    selection: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        selected: PropTypes.bool,
        label: PropTypes.node,
    })).isRequired,
    onSelectionChange: PropTypes.func.isRequired,
};
var defaultProps = {
    menuPosition: 'left',
    isOpen: false,
    disabled: false,
};

export { MenuPositions, defaultProps, propTypes };
